import angular from 'angular';

angular.module('myConsultApp').filter('keyLength', () => {
  return (obj) => {
    if (angular.isObject(obj)) {
      return Object.keys(obj).length;
    }
    return 0;
  };
});
